// Version : 1.0.0
// Author : AGALYA

/* eslint-disable import/no-anonymous-default-export */
import CurrentAddressActionType from './current-address.types';

const INITIAL_STATE = {
	// Save Address Data
	saveAddressData: null,
	// Current Address Response
	currentAddressResponse: null,
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** CURRENT ADDRESS DATA START *********************** */
		case CurrentAddressActionType.CURRENT_ADDRESS_ADD_CHANGED:
			return { ...state, saveAddressData: action.payload };

		case CurrentAddressActionType.CURRENT_ADDRESS_ADD_SUCCESS:
			return { ...state, currentAddressResponse: action.payload };

		case CurrentAddressActionType.CURRENT_ADDRESS_ADD_FAILURE:
			return { ...state, currentAddressResponse: action.payload };

		case CurrentAddressActionType.CURRENT_ADDRESS_ADD_RESPONSE_CHANGED:
			return { ...state, currentAddressResponse: null };
		/** ***************** CURRENT ADDRESS DATA END *********************** */

		default:
			return state;
	}
};
